import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmeraldDialog from 'src/common/components/emerald-dialog/emerald-dialog';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { ReactComponent as DecisionTakingIcon } from 'src/common/media/DecisionTaking.svg';
import { styles } from './tax-exemption-styles';
import { TextInput } from '@ncr-retail/base-retail-components';
import BaseButton from 'src/common/components/base-button';
import { handleTaxExemption, TaxExemptionData } from '../helper/tax-exemption-helper';
import { MissingExemptionCustomerIdAndName } from 'src/common/helpers/error-code';
import { showCustomerNameEntryModal } from './customer-name-entry-modal';

const Customer_Tax_Id_InputModal = 'Customer_Tax_Id_InputModal';
export const showCustomerTaxIdInputModal = (props: TaxExemptionData): void => {
  pushEmeraldModal(<CustomerTaxIdInputModal {...props} />, undefined, Customer_Tax_Id_InputModal);
};

export const CustomerTaxIdInputModal: React.FC<TaxExemptionData> = (
  props: TaxExemptionData,
): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const [textInput, setTextInput] = useState<string>('');
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const handleOnChange = (event): void => {
    const text = event.target.value;
    if (text === '') {
      setCanSubmit(false);
    } else {
      setTextInput(event.target.value);
      setCanSubmit(true);
    }
  };
  const onCancel = (): void => {
    popEmeraldModal(Customer_Tax_Id_InputModal);
  };
  const onSubmit = async (): Promise<void> => {
    props.taxExemptionDTO.taxExemptionPromptResults.customerExemptionId = textInput;
    if (props.taxExemptionErrorCode === MissingExemptionCustomerIdAndName) {
      showCustomerNameEntryModal(props);
      popEmeraldModal(Customer_Tax_Id_InputModal);
    } else {
      await handleTaxExemption(props, Customer_Tax_Id_InputModal);
    }
  };

  return (
    <EmeraldDialog
      open={true}
      fullWidth
      data-testid='customer-tax-exempt-id'
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <Grid container direction='column' className={classes.mainContainer}>
        <Grid item className={classes.title}>
          <Typography data-testid={'tax-header'} className={classes.titleContent}>
            {t('HeaderText_TaxExemption')}
          </Typography>
          <DecisionTakingIcon />
        </Grid>
        <Grid item container direction='column' className={classes.mainContent}>
          <Typography data-testid={'tax-id-message1'} className={classes.actionTitle}>
            {t('TaxId')}
          </Typography>
          <Typography data-testid={'tax-id-message2'} className={classes.actionSubTitle}>
            {t('TaxIdMessage')}
          </Typography>
          <Grid item className={classes.idTextInput}>
            <TextInput
              placeholder={t('TaxId')}
              autoComplete='off'
              inputProps={{
                'data-testid': 'tax-id-text-input',
                className: 'global-keyboard',
              }}
              onChange={handleOnChange}
            />
          </Grid>
          <Grid item container direction='row' className={classes.centerButtons}>
            <BaseButton
              buttonType='white'
              className={classes.cancelButton}
              onClick={onCancel}
              data-testid='cancel-button'
            >
              {t('Cancel_Button')}
            </BaseButton>
            <BaseButton
              className={classes.approveButton}
              onClick={onSubmit}
              data-testid='submit-button'
              disabled={!canSubmit}
            >
              {t('Ok')}
            </BaseButton>
          </Grid>
        </Grid>
      </Grid>
    </EmeraldDialog>
  );
};
